export const ANDROID_STORE =
  'https://play.google.com/store/apps/details?id=com.squareup.cash&referrer=utm_medium%3Dweb%26utm_source%3Dcash-web'
export const APPLE_STORE = 'https://itunes.apple.com/us/app/square-cash/id711923939?pt=302818&mt=8&ct=cash-web'
export const APP_DOWNLOAD_WITH_DEEP_LINK_PRODUCTION = 'https://click.cash.app/ui6m/b6ca51f0?deep_link_value='
export const APP_DOWNLOAD_WITH_DEEP_LINK_STAGING = 'https://click.cash.app/LhNg/35a5f3f8?deep_link_value='
